import React from 'react'
import 'split-pane-react/esm/themes/default.css';

const StructureQuestionPage = ({ soal, inputDisabled, answerState }) => {

    const handleChange = (e, number) => {
        const { value } = e.target
        let index = number - 1
        let _answer = [...answerState];
        _answer[index].user_answer = value
        _answer.push()
        console.log(answerState)
    }

    return (
        <div className='col-sm-12 p-5'>
            <div className='font-16' dangerouslySetInnerHTML={{ __html: soal.text_description }} />
            {
                soal.part_soal.map((m, i) => {
                    return (
                        <>
                            <tbody key={i}>
                                <div className='row' >
                                    <div className='font-16' dangerouslySetInnerHTML={{ __html: m.text_direction }} />
                                    <h3 className='text-center'>{m.part_name}</h3>
                                    {
                                        m.soal?.map((s, k) => {
                                            return (
                                                <div key={k+'i'} className='col-sm-6' style={{ marginBottom: '10px' }}>
                                                    <tr>
                                                    <td style={{ verticalAlign: 'top', fontSize: '16px' }}> <strong>{s.number}.</strong> &nbsp;&nbsp; </td>
                                                    <td>
                                                    <div dangerouslySetInnerHTML={{ __html: s.text_soal }} />
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                       <td></td>
                                                        <td >
                                                            <>
                                                                <div className='form-check'>
                                                                    <input disabled={inputDisabled ? true : false} className='form-check-input font-16' type="radio" value='A' onChange={(e) => handleChange(e, s.number)} name={`input${s.number}`} id={`input${s.number}`} /> <span className='font-16'>A. {s.opt_a}</span>
                                                                </div>
                                                                <div className='form-check'>
                                                                    <input disabled={inputDisabled ? true : false} className='form-check-input font-16' type="radio" value='B' onChange={(e) => handleChange(e, s.number)} name={`input${s.number}`} id={`input${s.number}`} /><span className='font-16'>B. {s.opt_b}</span>
                                                                </div>
                                                                <div className='form-check'>
                                                                    <input disabled={inputDisabled ? true : false} className='form-check-input font-16' type="radio" value='C' onChange={(e) => handleChange(e, s.number)} name={`input${s.number}`} id={`input${s.number}`} /><span className='font-16'>C. {s.opt_c}</span>
                                                                </div>
                                                                <div className='form-check'>
                                                                    <input disabled={inputDisabled ? true : false} className='form-check-input font-16' type="radio" value='D' onChange={(e) => handleChange(e, s.number)} name={`input${s.number}`} id={`input${s.number}`} /><span className='font-16'>D. {s.opt_d}</span>
                                                                </div>
                                                            </>
                                                        </td>
                                                    </tr>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </tbody>
                        </>
                    )
                })
            }
        </div>
    )
}

export default StructureQuestionPage
